import { format } from "date-fns";
import { formatDate, formatNumber, parseDateDisplay, parseDate } from "$root/localization/formatters";
import type { DataTypeDefinition } from "ag-grid-community";

export const decimalPlaces = 2;
export const commonColumnDataDefinition = {
	percentage: {
		baseDataType: "number",
		extendsDataType: "number",
		columnTypes: "rightAlignedCell",
		valueFormatter: (params) =>
			params.value == null || Number.isNaN(params.value) ? "N/A" : `${formatNumber(params.value, decimalPlaces)}%`,
	} satisfies DataTypeDefinition,
	floating: {
		baseDataType: "number",
		extendsDataType: "number",
		columnTypes: "rightAlignedCell",
		valueFormatter: (params) =>
			params.value == null || Number.isNaN(params.value) ? "N/A" : formatNumber(params.value, decimalPlaces),
	} satisfies DataTypeDefinition,
	integer: {
		baseDataType: "number",
		extendsDataType: "number",
		columnTypes: "rightAlignedCell",
		valueFormatter: (params) =>
			params.value == null || Number.isNaN(params.value) ? "N/A" : formatNumber(params.value, 0),
	} satisfies DataTypeDefinition,
	number: {
		baseDataType: "number",
		extendsDataType: "number",
		columnTypes: "rightAlignedCell",
	} satisfies DataTypeDefinition,
	mdotmDate: {
		baseDataType: "dateString",
		extendsDataType: "dateString",
		valueFormatter: (params) => {
			if (params.value == null || !params.value) {
				return "";
			}
			return formatDate(params.value);
		},
		valueParser: (params) => {
			const raw = params.newValue;
			if (raw == null || typeof raw !== "string" || raw.trim() === "") {
				return undefined;
			}
			const trimmed = raw.trim();

			// Already ISO YYYY-MM-DD — pass through
			if (/^\d{4}-\d{2}-\d{2}$/.test(trimmed)) {
				return trimmed;
			}

			// Localized display format: "25 Mar 2024", "25 mar 2024" (from in-app copy)
			const fromDisplay = parseDateDisplay(trimmed);
			if (fromDisplay !== null) {
				return fromDisplay;
			}

			// Locale short-date format: "25/03/2024", "3/25/2024" (from Excel/external paste)
			const fromShort = parseDate(trimmed);
			if (fromShort !== null) {
				const d = new Date(fromShort);
				if (!Number.isNaN(d.getTime())) {
					return format(d, "yyyy-MM-dd");
				}
			}

			return undefined;
		},
	} satisfies DataTypeDefinition,
};
